import React, { useState, useEffect } from "react";
import Sidebar from "../../commons/Sidebar/Sidebar";
import Header from "../../commons/Header/Header";
import { useLocation } from "react-router-dom";
import RestaurantList from "./Restaurant/Restaurant";
import "notosans-fontface/css/notosans-fontface.css";
import PendingRestaurant from "./PendingRestaurant/PendingRestaurant";
import RejectedRestaurant from "./RejectedRestaurant/RejectedRestaurant";
import Restaurant from "./Restaurant/Restaurant";

function PayoutManagement() {
  const location = useLocation();
  const [cms, setCms] = useState({
    type: "restaurant",
  });
  useEffect(() => {
    if (location?.state) {
      setCms({ type: location.state });
    }
  }, [location.state]);

  return (
    <>
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar status={true} />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="heading mb-4">
                <h3 className="text-default weight-400">Payout Management</h3>
              </div>
              <div className="row mx-0 main-content-body">
                <div className="col-md-12 mb-26 px-0 mt-0">
                  <ul
                    className="nav common-tabs cms-tabs w-100"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item mr-3">
                      <a
                        className={`nav-link br-10 w-auto mx-0 text-center px-5 ${
                          cms.type === "restaurant" ? "active" : undefined
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setCms({ type: "restaurant" })}
                      >
                        Restaurant
                      </a>
                    </li>
                    <li className="nav-item mr-3">
                      <a
                        className={`nav-link br-10 w-auto mx-0 text-center px-5 ${
                          cms.type === "driver" ? "active" : undefined
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setCms({ type: "driver" })}
                      >
                        Driver
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-12 tab-content row px-0 mx-0 mt-4">
                  {cms.type === "restaurant" ? (
                    <Restaurant/>                    
                  ) : cms.type === "driver" ? (
                    <PendingRestaurant/>
                ) :""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PayoutManagement;